/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

export default [
  {
    name: routeNames.FISHING_AREA,
    path: 'fishing-area/:areaId',
    component: () =>
      import('@/fish/components/fishing-areas/fishing-area-card'),
  },
  {
    name: routeNames.FISHING_AREA_SPECIES,
    path: 'fishing-area/:id/:speciesSlug',
    component: () => import('@/fish/components/species/fish-species-card'),
  },
  {
    name: routeNames.POLYGON,
    path: 'fishing-area/cluster/:coord',
    redirect: { name: routeNames.POLYGON_OVERVIEW },

    component: () =>
      import(
        /* webpackPrefetch: true */ '@/fish/components/fishing-areas/catch-data-card.vue'
      ),
    children: [
      {
        name: routeNames.POLYGON_OVERVIEW,
        path: 'overview',
        component: () =>
          import(
            /* webpackPrefetch: true */ '@/fish/components/fishing-areas/catch-data-overview.vue'
          ),
      },
    ],
  },
]
